"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidJishoResponse = void 0;
const zod_1 = require("zod");
const JishoApiEntrySense = zod_1.z.object({
    english_definitions: zod_1.z.string().array(),
    links: zod_1.z
        .object({
        text: zod_1.z.string(),
        url: zod_1.z.string(),
    })
        .array(),
    parts_of_speech: zod_1.z.string().array(),
    see_also: zod_1.z.string().array(),
    tags: zod_1.z.string().array(),
});
const JishoApiEntry = zod_1.z.object({
    attribution: zod_1.z.object({
        dbpedia: zod_1.z.union([zod_1.z.string(), zod_1.z.boolean()]),
        jmdict: zod_1.z.boolean(),
        jmnedict: zod_1.z.boolean(),
    }),
    is_common: zod_1.z.boolean().optional(),
    japanese: zod_1.z
        .object({
        reading: zod_1.z.string().optional(),
        word: zod_1.z.string().optional(),
    })
        .array(),
    jlpt: zod_1.z.string().array(),
    senses: JishoApiEntrySense.array(),
    slug: zod_1.z.string(),
    tags: zod_1.z.string().array(),
});
const JishoApiResponse = zod_1.z.object({
    data: JishoApiEntry.array(),
    meta: zod_1.z.object({
        status: zod_1.z.number(),
    }),
});
const isValidJishoResponse = (x) => {
    try {
        JishoApiResponse.parse(x);
        return true;
    }
    catch (e) {
        console.error(e);
        return false;
    }
};
exports.isValidJishoResponse = isValidJishoResponse;
//# sourceMappingURL=jisho_api.js.map